









import { Vue, Component } from "vue-property-decorator"
import NewArticle from "@/views/NewArticle.vue"

@Component({
  components: { NewArticle },
})
export default class EditArticle extends Vue {
  private id = -1

  public created(): void {
    this.id = parseInt(this.$route.params.id, 10)
  }
}
